import { Component, OnInit, OnDestroy, ViewChild, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingStepperSmartComponent } from '@app/booking-part/booking-stepper/booking-stepper.smart.component';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';
import { IBeginBookingFlowInfo } from '@app/shared/services/booking/begin-booking-flow-info.model';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BookingStepsFormService } from '../../../shared/services/booking-steps-form/booking-steps-form.service';

@Component({
  selector: 'app-steps-summary',
  templateUrl: './steps-summary.smart.component.html',
  styleUrls: ['./steps-summary.smart.component.scss']
})
export class BookingPartStepsSummarySmartComponent implements OnInit, OnDestroy {

  @ViewChild('bookingStepper') bookingStepper: BookingStepperSmartComponent;
  @Input() bookingFlowInfo: IBeginBookingFlowInfo;

  public currentLang: string;

  private readonly bookingStepsFormService = inject(BookingStepsFormService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);
  private bookingStepsForm: BookingStepsFormType;
  private masterSubscription = new Subscription();

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.bookingStepsForm = this.bookingStepsFormService.buildForm(this.bookingFlowInfo);
    this.currentLang = this.translateService.currentLang;
    this.masterSubscription.add(this.translateService.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.currentLang = event.lang;
      }));
    this.masterSubscription.add(this.bookingStepsForm.controls.employees.valueChanges.subscribe());
  }

  public onTreatmentChangeClick(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  public onEditVisitSlotStep(): void {
    this.bookingStepper.previous();
  }

  public moveToNextStep(): void {
    this.bookingStepper.next();
  }
}
